var exports = {
  "k": "x112a1f60--5ce952--container",
  "K": "x112a1f60--5ce952--icon",
};

module.exports = exports;
